/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useLocation } from 'react-router-dom';

/**
 * React hook to return a DXP Console redirect path.
 */
export function useRedirectPath(): string {
  const location = useLocation();
  const redirectPath = new URLSearchParams(location.search).get(`redirect_path`);

  // Make sure redirect is valid
  if (redirectPath) {
    return redirectPath[0] === `/` ? redirectPath : `/${redirectPath}`;
  }

  return `/`;
}
